import {
  Anchor,
  Button,
  Group,
  Image,
  Modal,
  Stack,
  Text,
} from "@mantine/core";
import { IconDownload } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import QRCode from "qrcode";

export function QrModal({ opened, onClose, url, label }) {
  const [dataUrl, setDataUrl] = useState(null);

  useEffect(() => {
    if (opened && url) {
      QRCode.toDataURL(url, { width: 512, margin: 2 }).then(setDataUrl);
    } else {
      setDataUrl(null);
    }
  }, [opened, url]);

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      centered
      radius="md"
      title={<Text fw={600}>QR Kod — {label}</Text>}
    >
      <Stack align="center" gap="md">
        {dataUrl ? <Image src={dataUrl} w={280} h={280} /> : null}
        <Anchor
          href={url ?? undefined}
          target="_blank"
          rel="noreferrer"
          size="sm"
          ta="center"
          style={{ wordBreak: "break-all" }}
        >
          {url}
        </Anchor>
        <Group>
          <Button variant="default" onClick={onClose}>
            Kapat
          </Button>
          <Button
            component="a"
            href={dataUrl ?? "#"}
            download={`qr-${label}.png`}
            leftSection={<IconDownload size={16} />}
            disabled={!dataUrl}
          >
            PNG İndir
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
